
<div class="header">
    <div class="headernavbar">
            <app-nav-bar [imglogoUrl]="headerData?.logo[0]?.url"></app-nav-bar>
    </div>
    <div class="headerbanner">
        <app-banner></app-banner>

    </div>

</div>